module.exports = __webpack_public_path__ + "img/spider-gazelle.1043dffd.svg";